<div>
  <!-- Action Buttons -->
  <div style="margin-bottom: 10px; text-align: right;">
    <button (click)="print()" class="noPrint" mat-raised-button color="primary">Print</button>
    <button class="noPrint" (click)="exportExcel('dispatchwise_report')" mat-raised-button
      color="primary">Export</button>
    <button class="noPrint" mat-button mat-dialog-close>Close</button>
  </div>

  <!-- Report Table -->
  <div id="print-section">
    <table border="1" cellspacing="0" cellpadding="5"
      style="width:100%; border-collapse: collapse; margin-left: 5px; margin-right: 10px;">
      <thead>
        <tr>
          <th colspan="8"
            style="text-align:center; font-size:20px; font-weight:bold; background-color: #d9e7ff; color:black;">
            Officewise Report
          </th>
        </tr>
        <tr style="background-color: #f0f0f0; font-weight:bold;">
          <th>Sr. No</th>
          <th>Seller Name</th>
          <th>Taluka</th>
          <th>District</th>
          <th>Representative</th>
          <th>Copies</th>
          <th>Delivery<br> Sub Mode</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let office of sellerData">
          <!-- Office Header -->
          <tr>
            <td colspan="8" style="font-weight:bold; background-color: #d9e7ff; color: red; font-size: 18px;">
              Office Representative: {{ office.office_representation_id }}
            </td>
          </tr>

          <!-- Office Data Rows -->
          <ng-container *ngFor="let item of office.data; let i = index">
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ item.issue_seller_id }}</td>
              <td>{{ item.taluka }}</td>
              <td>{{ item.district }}</td>
              <td>{{ item.representative_id }}</td>
              <td>{{ item.issue_copies }}</td>
              <td>{{ item.delevery_sub_mode_id }}</td>
            </tr>
          </ng-container>

          <!-- Office Total Row -->
          <tr style="font-weight:bold; background-color:#f0f0f0;color: blue;font-size: 18px;">
            <td colspan="5" style="text-align:right;">Total Copies for {{ office.office_representation_id }}:</td>
            <td>{{ getOfficeTotalCopies(office) }}</td>
            <td></td>
          </tr>
           </ng-container>
          <tr style="font-weight:bold; background-color:#d9e7ff; color: black; font-size: 18px;">
            <td colspan="5" style="text-align:right;">Grand Total Copies:</td>
            <td>{{ getGrandTotalCopies() }}</td>
            <td></td>
          </tr>

       
      </tbody>
    </table>
  </div>
</div>